import React from 'react';
import router, { useRouter } from 'next/router';
import styles from '../../../styles/pages/SinglePost.module.scss';
import { HTMLReactParserOptions, domToReact } from 'html-react-parser';
import useResponsive from '../../../utils/hooks/useResponsive';
import useAuthenticated from '../../../utils/hooks/useAuthenticated';
import useWebView from '../../../utils/hooks/useWebView';
import getConfig from 'next/config';

import { NORMAL_MENU, LOGIN_MENU, ACCOUNT_PROPS, INSURANCE_LINKS, TOOLS_PROPS, EXPLORE_PROPS } from '../../../lib/bottomNavConstant';
import BottomNavigation from '../../BottomNavigation';

const Page = ({ page }) => {
  const authenticated = useAuthenticated();
  const { isDesktop } = useResponsive();
  const router = useRouter();
  const isWebView = useWebView(router);
  const { CORE_URL } = getConfig().publicRuntimeConfig;

  const aboutPageOptions: HTMLReactParserOptions = {
    replace: ({ attribs, children }: any) => {
      if (attribs && attribs.class) {
        if (attribs.class.includes('row')) {
          return <div className={styles['section']}>{domToReact(children, aboutPageOptions)} </div>
        }

        if (attribs.class.includes('col-3 col-md-1 mb-4')) {
          return <div className={styles['small__img']}>{domToReact(children, aboutPageOptions)} </div>
        }

        if (attribs.class.includes('col-9 col-md-3')) {
          return <div className={styles['small__text']}>{domToReact(children, aboutPageOptions)} </div>
        }
      }
    }
  };
  
  return (
    <>
      { page.slug === 'tentang' &&
        <div className="container single-page-about">
          <div className="row first-section">
            <div className="first-section-left">
              <h1 className="section-title">Broker Asuransi Terbaik di Indonesia</h1>
              <p className="section-body">Lifepal adalah broker asuransi yang berdiri sejak tahun 2018 dengan misi untuk memberikan kemudahan bagi nasabah dalam membandingkan ratusan polis asuransi secara online. Lifepal terus berkembang dan kini telah bermitra dengan sejumlah perusahaan asuransi ternama di Indonesia</p>
            </div>
            <div className="first-section-right text-center"><img className="alignnone size-medium wp-image-224001" src="https://blog-media.lifepal.co.id/app/uploads/sites/3/2024/06/27172508/Illustration-44-304x300.png" alt="" width="360" height="auto" /></div>
          </div>
          <div className="row section">
            <div className="col-12 col-md-10 offset-md-1 text-center">
              <h2 className="section-title">Di Balik Lifepal</h2>
              <p className="section-body">Lifepal beroperasi di bawah izin PT Anugrah Atma Adiguna sebagai pialang asuransi berizin dan diawasi oleh OJK sesuai KEP-018/KMK.17/1992 dan anggota APPARINDO 60-2001/APPARINDO/2024.</p>
            </div>
          </div>
          <div className="row third-section">
            <div className="text-center">
              <h2 className="section-title">Mitra Asuransi Lifepal</h2>
              <div className="row section-body flex">
                <a href={`${CORE_URL}/asuransi/mobil-mega-insurance/`}>
                  <div className="image-wrapper">
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-mega.svg" alt="asuransi-mega" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>Mega Insurance</span>
                    </div>
                  </div>
                </a>
                <a href={`${CORE_URL}/asuransi/kb-insurance/`}>
                  <div className="image-wrapper">
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-kb.svg" alt="asuransi-kb" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>KB Insurance</span>
                    </div>
                  </div>
                </a>
                <a href={`${CORE_URL}/asuransi/simas-insurtech/`}>
                  <div className="image-wrapper">
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-simas-insurtech.svg" alt="asuransi-simas-insurtech" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>Simas Insurtech</span>
                    </div>
                  </div>
                </a>
                <a href={`${CORE_URL}/asuransi/mobil-garda-oto/`}>
                  <div className="image-wrapper">
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-garda-oto.svg" alt="asurans-garda-oto" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>Astra Garda Oto</span>
                    </div>
                  </div>
                </a>
                <a href={`${CORE_URL}/asuransi/mobil-mag/`}>
                  <div className="image-wrapper">  
                    <div>
                    <img src="/media/static/images/brand-insurance/asuransi-mag.svg" alt="asuransi-mag" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>MAG Insurance</span>
                    </div>
                  </div>
                </a>                
                <a href={`${CORE_URL}/asuransi/mobil-aca/`}>
                  <div className="image-wrapper">
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-aca.svg" alt="asuransi-aca" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>ACA</span>
                    </div>
                  </div>
                </a>
              </div>
              <div className="row section-body flex">                
                <a href={`${CORE_URL}/asuransi/zurich-syariah/`}>
                  <div className="image-wrapper">
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-zurich-syariah.svg" alt="asuransi-zurich-syariah" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>Zurich Syariah</span>
                    </div>
                  </div>      
                </a>                               
                <a href={`${CORE_URL}/asuransi/staco-mandiri/`}>
                  <div className="image-wrapper">    
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-staco.svg" alt="asuransi-staco" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>Staco Mandiri</span>
                    </div>
                  </div>            
                </a>          
                <a href={`${CORE_URL}/asuransi/kesehatan-lippo/`}>
                  <div className="image-wrapper">
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-lippo.svg" alt="asuransi-lippo" width="156" height="auto" />
                    </div>
                    <div className='brand-title' style={{width:156}}>
                      <span>Lippo General Insurance</span>
                    </div>
                  </div>         
                </a> 
                <a href={`${CORE_URL}/asuransi/kesehatan-axa/`}>  
                  <div className="image-wrapper">
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-axa.svg" alt="asuransi-axa" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>AXA Insurance</span>
                    </div>
                  </div>        
                </a>     
                <a href={`${CORE_URL}/asuransi/sunlife/`}>   
                  <div className="image-wrapper">
                    <div>
                      <img src="/media/static/images/brand-insurance/asuransi-sunlife.svg" alt="asuransi-sunlife" width="156" height="auto" />
                    </div>
                    <div className='brand-title'>
                      <span>Sun Life</span>
                    </div>
                  </div>
                </a>    
              </div>
            </div>
          </div>
          <div className="row forth-section">
            <div className="text-center">
              <h2 className="section-title">Nilai Yang Kami Percaya</h2>
              <div className="section-body">
                <div className="section-body-group">
                  <div className="section-body-img"><img src="/media/static/images/Customer First.svg" alt="" width="64" height="64" /></div>
                  <div className="section-body-txt">
                    <div className="section-body-txt-title">Customer First</div>
                    <div className="section-body-txt-subtitle">Lifepal memastikan bahwa setiap produk dan layanan yang kami berikan berpusat pada nasabah. Dengan terus berinovasi, Lifepal secara konsisten memberikan pengalaman yang positif dalam menghadirkan proteksi asuransi yang mudah dijangkau bagi setiap orang.</div>        
                  </div>
                </div>
                <div className="section-body-group">
                  <div className="section-body-img"><img src="/media/static/images/Ownership.svg" alt="" width="64" height="64" /></div>
                  <div className="section-body-txt">
                    <div className="section-body-txt-title">Ownership</div>
                    <div className="section-body-txt-subtitle">Lifepal berdedikasi untuk mendapatkan dan menjaga kepercayaan nasabah di setiap langkah. Dengan tim yang kuat dan berpengalaman dibidangnya, Lifepal memastikan setiap kebutuhan nasabah dapat dipenuhi dengan tanggung jawab serta dedikasi tinggi.</div>         
                  </div>                  
                </div>
                <div className="section-body-group">
                  <div className="section-body-img"><img src="/media/static/images/Integrity.svg" alt="" width="64" height="64" /></div>
                  <div className="section-body-txt">
                    <div className="section-body-txt-title">Integrity</div>
                    <div className="section-body-txt-subtitle">Lifepal terus berusaha untuk selalu transparan dan secara konsisten selaras dengan nilai-nilai yang kami pegang dalam setiap interaksi dengan nasabah. Komitmen kami menjamin setiap nasabah mendapatkan layanan dan produk asuransi terbaik yang sesuai dengan kebutuhan.  
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      { page.slug !== 'tentang' &&
        <div
          className={styles['single-page__wrapper']}
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
      }

      {!isDesktop && authenticated && !isWebView && (
        <BottomNavigation
          activePath={router.asPath}
          isLoggedIn={authenticated}
          normalMenu={NORMAL_MENU} //menu when user isn't logged in TODO: fix
          loginMenu={LOGIN_MENU}
          accountProps={ACCOUNT_PROPS} //props for Account section in normal menu
          insuranceLinks={INSURANCE_LINKS}
          toolsProps={TOOLS_PROPS}
          exploreProps={EXPLORE_PROPS}
        />
      )}
    </>
  );
};

export default Page;
